export default class FieldUtil {

    constructor(field) {
        this.field = field
    }

    isCollaborator() {
        return this.field.field_type === 'Collaborator'
    }

    isCurrentUser() {
        return this.isCollaborator() && this.field.metadata && this.field.metadata.currentUser
    }

    editable() {
        return this.field.field_type !== 'Link to Object' && this.field.field_type !== 'Dynamic' &&
            !this.isFixedCollaborator()
    }

    isFixedCollaborator() {
        return this.field.field_type === 'Collaborator' && this.isUserFixed()
    }

    isUserFixed() {
        return this.field.metadata && this.field.metadata['currentUser']
    }

    isNumeric() {
        return this.field.field_type === 'Dynamic' || this.field.field_type === 'Number'
    }

}